export const PROGRESS_REPORT_PAGE_LIMIT = 100;

const state = () => ({
  progressReports: {},
  progressReportIds: [],
  pagination: {
    totalCount: 0,
    limit: PROGRESS_REPORT_PAGE_LIMIT,
    offset: 0,
  },
});

const getters = {
  progressReports: state => state.progressReports,
  all: state => state.progressReportIds
    .map(id => state.progressReports[id])
    .sort((a, b) => new Date(b.generatedAt) - new Date(a.generatedAt)),
  get: state => id => state.progressReports[id],
  pagination: state => state.pagination,
  unreadCount: (state, getters) => getters.all.filter(report => !report.readAt).length,
};

// The list endpoint omits `html`, so merge rather than replace to keep any body
// already pulled from the detail endpoint.
function mergeProgressReport(state, progressReport) {
  state.progressReports[progressReport.id] = {
    ...state.progressReports[progressReport.id],
    ...progressReport,
  };
  if (!state.progressReportIds.includes(progressReport.id)) {
    state.progressReportIds.push(progressReport.id);
  }
}

const mutations = {
  setProgressReports(state, { progressReports, totalCount, limit, offset }) {
    progressReports.forEach(progressReport => mergeProgressReport(state, progressReport));
    state.pagination = { totalCount, limit, offset };
  },
  setProgressReport(state, progressReport) {
    mergeProgressReport(state, progressReport);
  },
};

const actions = {
  fetchProgressReports({ commit, rootGetters }, { limit = PROGRESS_REPORT_PAGE_LIMIT, offset = 0 } = {}) {
    return rootGetters['session/ajax']
      .get('/progress_reports', { params: { limit, offset } })
      .then(response => {
        commit('setProgressReports', {
          progressReports: response.data.progressReports,
          totalCount: response.data.totalCount,
          limit: response.data.limit,
          offset: response.data.offset,
        });
        return response.data.progressReports;
      });
  },
  fetchProgressReport({ commit, rootGetters }, id) {
    return rootGetters['session/ajax'].get(`/progress_reports/${id}`).then(response => {
      commit('setProgressReport', response.data.progressReport);
      return response.data.progressReport;
    });
  },
  updateReadAt({ commit, rootGetters }, { id, readAt }) {
    const data = readAt === undefined ? {} : { readAt };
    return rootGetters['session/ajax'].patch(`/progress_reports/${id}`, data).then(response => {
      commit('setProgressReport', response.data.progressReport);
      return response.data.progressReport;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
